export default {
  nestedBackgroundDesign: true,
  slidesContainer: true,
  focusable: true,
  canContain: false,
  canContainByStructure: false,
  allowLassoOnContainer: true,
  pinnable: false,
};
